import EntityBase from '@/data/EntityBase';

export default class HourStatsScheduledState extends EntityBase({
  updating: 0,
}) {}
